import { VelavuRuleValidationError, VelavuRuleValidationErrorType, } from "../data/rule";
import { VelavuRequestError } from "../error/error";
import { fetchJSON, fetchWithAuth } from "../util/fetch-utils";
/**
 * Maps an error to an {@link VelavuRuleValidationError} if possible
 */
function mapRuleValidationError(error) {
    if (error instanceof VelavuRequestError) {
        //Check if the body matches a known validation error
        if (Object.values(VelavuRuleValidationErrorType).some((type) => error.reason === type)) {
            //If so, return a new validation error
            return new VelavuRuleValidationError(error);
        }
    }
    return error;
}
export default class VelavuAPIRules {
    //This endpoint retrieves all rules.
    getAllRules() {
        return fetchJSON("/rules");
    }
    //This endpoint retrieves a single rule by its ID.
    getSpecificRule(ruleID) {
        return fetchJSON(`/rules/${ruleID}`);
    }
    //This creates a new rule object.
    createNewRule(params) {
        return fetchJSON("/rules", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(params),
        }).catch((error) => {
            throw mapRuleValidationError(error);
        });
    }
    //This modifies an existing rule object.
    modifyExistingRule(ruleID, params) {
        return fetchJSON(`/rules/${ruleID}`, {
            method: "PATCH",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(params),
        }).catch((error) => {
            throw mapRuleValidationError(error);
        });
    }
    //This method deletes a rule.
    deleteRule(ruleID) {
        return fetchWithAuth(`/rules/${ruleID}`, {
            method: "DELETE",
        });
    }
}
//# sourceMappingURL=velavu-api-rules.js.map